import {CreateOperationalEntityResultV2} from "@common-core/coat-operational-hierarchy-appsync-model";
import {CreateResultNode} from "../view-model";

export const toCreateResultNodeV2 = (
  result: CreateOperationalEntityResultV2
): CreateResultNode => ({
  caId: result.sources[0].sourceId,
  oeId: result.id,
  dbaName: result.dbaName,
  tenantId: result.tenantId,
  status: result.status,
  message: result.message,
  children: result.children ? result.children.map(toCreateResultNodeV2) : []
});
